import React from "react";
import Page from "../../components/DefaultPage/DefaultPage";
//import GBBG from "./Presentation1.jpg";
import GBBG from "../../images/carousel/green-bear.jpg";
import Overlay1 from "./applestore.png"; // substitua com o nome da imagem 1
import Overlay2 from "./googlestore.png"; // substitua com o nome da imagem 2
//import LogoGreenBear from "./LogoGreenBear.png"; 
import LogoGreenBear from "../../images/logo/GreenBearLogo.png"; 
import IphoneQrCode from "./IphoneQrCode.jpg"; 
import AndroidQrcode from "./AndroidQrcode.jpg"; 
//import classes from "./LandPage.module.css";
import classes from "./LandPage.module.css";

export default function Objectives() {
  const landpage = true;

  return (
    <Page landpage={landpage}>
      <div className={`${classes.pageContent} ${classes.content_margin} ${classes.background_image}`}>
        <div className={classes.imageWrapper}>
          
          <div className={classes.imageWrapper}>
            <img
              src={LogoGreenBear}
              alt="Logo ursoverde"
              className={classes.image_main}
            />
          </div>

            <div className={`${classes.flex_container}`}>
                <div className={`${classes.flex_item}`}>
                  <a className={`${classes.flex_container_column}`}
                    href="https://apps.apple.com/pt/app/ursoverde-2024/id6495227760"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                  
                  <img width="300"
                    src={Overlay1}
                    alt="Imagem sobreposta 1"
                  />
                  <img width="300"
                    src={IphoneQrCode}
                    alt="QRcode Iphone"
                  />
                </a>
              </div>
                <div className={`${classes.flex_item}`}>
                  <a className={`${classes.flex_container_column}`}
                  href="https://play.google.com/store/apps/details?id=com.socialite.ursoverde"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img width="300"
                    src={Overlay2}
                    alt="Imagem sobreposta 2"
                  />
                  <img width="300"
                    src={AndroidQrcode}
                    alt="QRcode Android"
                  />
                </a>
              </div>
            </div>

          
          </div>
      </div>
    </Page>
  );
}
